import { memo, type ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { gradeMessages } from '@didaskill/ui/intl';

export type FormattedGradeProps = {
  /** Grade of the student. */
  grade: number;
  /** Max grade of the assignment. */
  gradingScale: number;
  /** Component to render the grade. Passed to FormattedMessage. */
  renderGrade?: (chunks: ReactNode[]) => ReactNode;
  /** Component to render the gradingScale. Passed to FormattedMessage. */
  renderGradingScale?: (chunks: ReactNode[]) => ReactNode;
};

const DEFAULT_RENDER_GRADE = (chunks: ReactNode[]) => chunks;
const DEFAULT_RENDER_GRADING_SCALE = (chunks: ReactNode[]) => chunks;

export const FormattedGradeBase = ({
  grade,
  gradingScale,
  renderGrade = DEFAULT_RENDER_GRADE,
  renderGradingScale = DEFAULT_RENDER_GRADING_SCALE,
}: FormattedGradeProps) => (
  <span>
    <FormattedMessage
      {...gradeMessages.GRADE}
      values={{
        grade,
        gradingScale,
        Grade: renderGrade,
        GradingScale: renderGradingScale,
      }}
    />
  </span>
);

FormattedGradeBase.displayName = 'FormattedGrade';

export const FormattedGrade = memo(FormattedGradeBase);
